function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.2.9c-.9-.6-1.9-.9-3-.9-1.8 0-3.5.9-4.5 2.4l-9.1 14c-.3.4-.3.8-.3 1.3l1 4.9c.1.5.4.9.7 1.1.3.2.6.3 1 .3H3.3l5.1-1c.5-.1.9-.4 1.1-.8l9.1-13.9c1.7-2.5 1.1-5.8-1.4-7.4zM7.1 19.6l-2.6.5-.5-2.4 8.7-13.4c.3-.5.9-.8 1.5-.8.4 0 .7.1 1 .3.8.6 1.1 1.7.5 2.6L7.1 19.6z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), _ref);
};

export default SvgComponent;